/**
 * Action types for hiSense Graph functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle hiSense graph.
*/

export const HI_SENSE_GRAPH_API_LOADING = 'HI_SENSE_GRAPH_API_LOADING';
export const SAVE_HI_SENSE_GRAPH = 'SAVE_HI_SENSE_GRAPH';

// for group site
export const SAVE_SITE_HI_SENSE_STATS_QUERY_GRAPH = 'SAVE_SITE_HI_SENSE_STATS_QUERY_GRAPH';
export const SITE_HI_SENSE_STATS_QUERY_GRAPH_LOADING = 'SITE_HI_SENSE_STATS_QUERY_GRAPH_LOADING';